export default {
  name: "Gerätemodellfähigkeit",
  plural: "Gerätemodellfähigkeiten",
  columns: {
    capability: "Fähigkeit",
    capabilityId: "Fähigkeit ID",
    deviceModelVersion: "Gerätemodellversion",
    deviceModelVersionId: "Gerätemodellversion ID",
    fieldSelector: "Feldauswahl",
    id: "ID",
    isDeleted: "ist gelöscht",
    technicalMax: "technische Max",
    technicalMin: "technische Min",
    tenantId: "Mieter ID",
    unit: "Einheit",
    unitId: "Einheit ID",
  },
};
